// @generated by protoc-gen-es v2.16.0 with parameter "target=ts"
// @generated from file responses/v1/carrier_service_response.proto (package responses.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from '@bufbuild/protobuf/codegenv2';
import { fileDesc, messageDesc } from '@bufbuild/protobuf/codegenv2';
import type { Message } from '@bufbuild/protobuf';

/**
 * Describes the file responses/v1/carrier_service_response.proto.
 */
export const file_responses_v1_carrier_service_response: GenFile =
    /*@__PURE__*/
    fileDesc(
        'CityZXNwb25zZXMvdjEvY2Fycmllcl9zZXJ2aWNlX3Jlc3BvbnNlLnByb3RvEgxyZXNwb25zZXMudjEiKQoWQ2FycmllclNlcnZpY2VSZXNwb25zZRIPCgdzdWNjZXNzGAEgASgIQoYBChBjb20ucmVzcG9uc2VzLnYxQhtDYXJyaWVyU2VydmljZVJlc3BvbnNlUHJvdG9QAVoELi9wYqICA1JYWKoCDFJlc3BvbnNlcy5WMcoCDFJlc3BvbnNlc1xWMeICGFJlc3BvbnNlc1xWMVxHUEJNZXRhZGF0YeoCDVJlc3BvbnNlczo6VjFiBnByb3RvMw'
    );

/**
 * CarrierServiceResponse answers the carrier service create and delete calls. Success is
 * true when the carrier service of the shop ended up as asked.
 *
 * @generated from message responses.v1.CarrierServiceResponse
 */
export type CarrierServiceResponse = Message<'responses.v1.CarrierServiceResponse'> & {
    /**
     * @generated from field: bool success = 1;
     */
    success: boolean;
};

/**
 * Describes the message responses.v1.CarrierServiceResponse.
 * Use `create(CarrierServiceResponseSchema)` to create a new message.
 */
export const CarrierServiceResponseSchema: GenMessage<CarrierServiceResponse> =
    /*@__PURE__*/
    messageDesc(file_responses_v1_carrier_service_response, 0);
